import React from 'react'
import { I18n } from '@front/volcanion'

import { IconUtils } from '@front/squirtle/utils'
import { B2Link } from '@front/squirtle/elements'

import { TableCell } from '@mui/material'

const Client = ({ row }) => {
  const isB2B = !!row?.service
  const record_id = !!isB2B ? row?.service?.contract?.company?.company_id : row?.do?.user_id
  const icon = IconUtils.getClientTypeIcon(isB2B)
  const tooltip = isB2B ? I18n.t('user.b2b') : I18n.t('user.b2c')
  return (
    <TableCell padding='none' sx={{ maxWidth: 150 }}>
      <B2Link
        isB2B={isB2B}
        record_id={record_id}
        icon={icon}
        _typography={{ noWrap: true, width: '98%' }}
        _tooltipIcon={{ enable: true, title: tooltip }}
        _tooltipText={{ enable: true }}
      />
    </TableCell >
  )
}

export default React.memo(Client)
